import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client';
import { createContext, useContext } from 'react';

interface ApolloContextType {
  atlasClient: ApolloClient<NormalizedCacheObject>;
  papiClient: ApolloClient<NormalizedCacheObject>;
  resetCache: () => Promise<any>;
  resetStore: () => Promise<any>;
}

const ApolloContext = createContext<ApolloContextType>(null as unknown as ApolloContextType);

export default ApolloContext;

export function useApolloContext() {
  return useContext(ApolloContext);
}
